import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Actions
import { archiveWorkspace } from 'Shared/actions/workspaces';

// Components
import ConfirmModal from 'Shared/components/ConfirmModal/ConfirmModal';

type Props = {
  workspaceId: string;
  isOpen: boolean;
  onToggle: Function;
};

const DeleteWorkspaceModal = ({ workspaceId, isOpen, onToggle }: Props) => {
  const dispatch = useDispatch();

  const [isDeleting, toggleIsDeleting] = useToggle(false);

  const handleDeleteClick = useCallback(() => {
    toggleIsDeleting();
    dispatch(archiveWorkspace(workspaceId));
  }, [workspaceId]);

  return (
    <ConfirmModal
      isOpen={isOpen}
      onToggle={onToggle}
      title="Delete Workspace"
      message="Are you sure you want to delete this workspace?"
      isProcessing={isDeleting}
      onConfirmClick={handleDeleteClick}
      confirmButtonLabel="Delete"
    />
  );
};

export default DeleteWorkspaceModal;
